import { render, staticRenderFns } from "./clickplay_faq.vue?vue&type=template&id=5dd7cc9e&scoped=true&"
import script from "./clickplay_faq.vue?vue&type=script&lang=js&"
export * from "./clickplay_faq.vue?vue&type=script&lang=js&"
import style0 from "./clickplay_faq.vue?vue&type=style&index=0&id=5dd7cc9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd7cc9e",
  null
  
)

export default component.exports